export default __webpack_public_path__ + "static/bg-5c397dd0a322036ed68f513006502192.webp";